(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/menu.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/menu.js');
"use strict";

var _svs$eInstant$data$mo, _svs$eInstant$data$mo2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useMemo,
  useEffect,
  useRef
} = React;
const {
  ItemsMenu,
  IconItem
} = svs.ui.ReactItemsMenu;
const {
  useHistory,
  useLocation,
  matchPath
} = ReactRouterDOM;
const {
  trackMenuClick
} = svs.eInstant.tracking;
const {
  PLAY,
  DEMO_PLAY,
  BET_DETAIL,
  CATEGORY,
  INFO,
  ALL_GAMES,
  FAVORITES
} = svs.eInstant.constants.ROUTES;
const menuItemsConfig = ((_svs$eInstant$data$mo = svs.eInstant.data.moduleConfig) === null || _svs$eInstant$data$mo === void 0 ? void 0 : _svs$eInstant$data$mo.menuItems) || [];
const {
  startPage,
  allGamesPage,
  favoritePage
} = ((_svs$eInstant$data$mo2 = svs.eInstant.data.moduleConfig) === null || _svs$eInstant$data$mo2 === void 0 ? void 0 : _svs$eInstant$data$mo2.fixedMenuItems) || {
  startPage: {},
  allGamesPage: {},
  favoritePage: {}
};
setGlobal('svs.eInstant.shared.components.Menu', () => {
  const history = useHistory();
  const location = useLocation();
  const menuItemsWrapperRef = useRef(null);
  const isPlayRoute = matchPath(location.pathname, {
    path: [PLAY, DEMO_PLAY, BET_DETAIL],
    exact: false
  });
  const isInfoMobile = matchPath(location.pathname, {
    path: [INFO],
    exact: false
  }) && svs.core.detect.formfactor.mobile();
  const categoryUrl = path => CATEGORY.replace(':categoryId', path);
  const menuItems = useMemo(() => [{
    title: startPage.title || 'Start',
    icon: startPage.icon || 'nav-home',
    urlPaths: ['/', INFO]
  }, {
    title: (favoritePage === null || favoritePage === void 0 ? void 0 : favoritePage.title) || 'Favoriter',
    icon: (favoritePage === null || favoritePage === void 0 ? void 0 : favoritePage.icon) || 'favorites',
    urlPaths: [FAVORITES, "".concat(FAVORITES).concat(INFO)],
    loginRequired: true
  }, ...menuItemsConfig.map(item => _objectSpread(_objectSpread({}, item), {}, {
    urlPaths: [categoryUrl(item.urlPath), "".concat(categoryUrl(item.urlPath)).concat(INFO)]
  })), {
    title: allGamesPage.title || 'Alla spel',
    icon: allGamesPage.icon || 'games',
    urlPaths: [ALL_GAMES, "".concat(ALL_GAMES).concat(INFO)]
  }], []);
  useEffect(() => {
    const onScroll = () => {
      const menuItems = document.querySelector('.js-items-menu-item');
      if (!menuItems) return;
      const iconHeight = menuItems.querySelector('.icon').parentElement; 
      const offset = menuItems.offsetHeight - iconHeight.offsetHeight;
      if (menuItemsWrapperRef.current) {
        menuItemsWrapperRef.current.style.setProperty('--itemMenuStickyOffset', "".concat(offset, "px"));
      }
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);
  if (isPlayRoute || isInfoMobile) return null;
  const handleOnClick = (e, url, title, loginRequired) => {
    e.preventDefault();
    trackMenuClick(title);
    if (loginRequired === true && !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.components.customer_login.login({
        returnUrl: svs.core.data.baseUrl + url,
        returnNewCustomer: true
      });
      return;
    }
    history.push(url);
  };
  return React.createElement("div", {
    className: "tickets-einstant-items-menu-wrapper",
    ref: menuItemsWrapperRef
  }, React.createElement(ItemsMenu, {
    centered: true,
    className: "tickets-einstant-items-menu",
    hiddenScrollbar: true,
    useScrollHelpers: true
  }, menuItems.map(_ref => {
    let {
      title,
      icon,
      urlPaths,
      loginRequired
    } = _ref;
    return React.createElement(IconItem, {
      alignment: "vertical",
      Component: "a",
      gutter: 1,
      href: "#",
      iconName: icon,
      isSelected: Boolean(urlPaths.find(path => location.pathname.endsWith(path) || matchPath(location.pathname, {
        path,
        exact: true,
        strict: true
      }))),
      key: urlPaths[0],
      label: title,
      onClick: e => handleOnClick(e, urlPaths[0], title, loginRequired)
    });
  })));
});

 })(window);